import PropTypes from 'prop-types';
import {
  List, ListItem, ListItemButton, ListItemText,
  Typography,
} from '@mui/material';
import {useEffect, useState} from 'react';
import i18n from 'i18next';
import {supportedLanguages} from '../../i18n/config';
import * as React from 'react';

export default function SelectLanguageStep({setLanguage, nextStep, handleChange}) {
  const [defaultLanguage] = useState(supportedLanguages[0]);

  useEffect(() => {
    i18n.changeLanguage(defaultLanguage.code);
  }, []);

  function updateLanguage(selectedLanguage) {
    i18n.changeLanguage(selectedLanguage.code);
    setLanguage(selectedLanguage);
    handleChange({language: selectedLanguage.code});
    nextStep();
  }

  return (
    <div>
      <Typography variant="h2" gutterBottom marked="center" align="center">
                LANGUAGE
      </Typography>
      <List>
        {supportedLanguages.map((language) => {
          return (
            <ListItem key={language.code}>
              <ListItemButton onClick={() => updateLanguage(language)}>
                <ListItemText primary={
                  <Typography variant="body1" align="center">
                    {language.name}
                  </Typography>
                }/>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
}

SelectLanguageStep.propTypes = {
  setLanguage: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
};
